import React, { useState, lazy } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import LazyModal from 'Components/Utility/LazyModal';
import { getSuggestedTagsByProductId } from 'Redux/ducks/product';

const UserTagsModal = lazy(() => import(/* webpackChunkName: "UserTagsModal" */ 'Components/Product/UserTags/UserTagsModal'));

const messages = defineMessages({
  tag_modal_subtitle: {
    id: 'reviewcardtagbutton.tag_modal_subtitle',
    defaultMessage: 'Help us define this {productType}. Choose the tags that are the most accurate and they will be added to the product page.',
  },
  game: {
    id: 'reviewcardtagbutton.game',
    defaultMessage: 'game',
  },
});

const ReviewCardTagButton = ({
  isAdmin,
  productId,
  intl: { formatMessage },
}) => {
  const [open, setOpen] = useState(false); // user tag modal
  const [tagData, setTagData] = useState({ tags: [], slug: '', type: '' });


  const onClick = async () => {
    const data = await getSuggestedTagsByProductId(productId);
    setTagData(data);
    setOpen(true);
  };

  const { slug, tags, type, name } = tagData;

  return (
    <React.Fragment>
      <button className="review-tag-button" onClick={() => onClick()}>
        <FontAwesomeIcon icon={faTag} />
      </button>

      <LazyModal
        hasCloseFooter
        open={open}
        setOpen={setOpen}
        className="user-tags-modal"
        size="lg"
      >
        <UserTagsModal
          tags={tags}
          name={name}
          slug={slug}
          type={type}
          isAdmin={isAdmin}
          subtitle={formatMessage(messages.tag_modal_subtitle, { productType: type === 'game' ? formatMessage(messages.game) : 'DLC' })}
        />
      </LazyModal>
    </React.Fragment>
  );
};

ReviewCardTagButton.propTypes = {
  isAdmin: PropTypes.bool,
  productId: PropTypes.string.isRequired,
};

ReviewCardTagButton.defaultProps = {
  isAdmin: false,
};

const mapStateToProps = ({
  auth,
}) => ({
  isAdmin: auth.role === 'admin',
});

export default connect(mapStateToProps)(injectIntl(ReviewCardTagButton));
